var map = {
	"./Footer/base-footer.vue": "FtRy",
	"./Header/HeaderCard.vue": "rUes",
	"./base/base-header-img.vue": "QRx4",
	"./base/base-title.vue": "so5u"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5Cm5";


//////////////////
// WEBPACK FOOTER
// ./src/components/modules \.vue
// module id = 5Cm5
// module chunks = 0